'use client';

import CWImage from '@/context/global/components/g00/g00-d00-g003-cw-image-fallback';
import CWSectionHeader from '@/context/global/components/g02/g02-d01/g02-d01-g002-cw-section-header';
import { ContentShelf } from '@/context/global/types/homeShelf';

type CWEventSingleCardProps = {
  shelf: ContentShelf;
};

export default function CWEventSingleCard({ shelf }: CWEventSingleCardProps) {
  const item = shelf.items[0];

  if (!item) return null;

  const handleClick = () => {
    window.open(item.contentUrl, '_blank');
  };

  return (
    <section className="w-full">
      <CWSectionHeader title={shelf.title} />
      <div
        className="relative mx-auto w-full max-w-screen-2xl cursor-pointer overflow-hidden rounded-2xl"
        onClick={handleClick}
        role="button"
        aria-label={item.title || 'Event banner'}
      >
        <div className="relative aspect-[16/5] w-full">
          <CWImage
            src={item.coverUrl}
            alt={item.title || 'Event'}
            className="object-contain object-center"
            // sizes="(max-width: 768px) 100vw, (max-width: 1200px) 90vw, 1400px"
          />
        </div>
      </div>
    </section>
  );
}
